import { render, staticRenderFns } from "./ModalDropdownIcon.vue?vue&type=template&id=54739c87&scoped=true&"
import script from "./ModalDropdownIcon.vue?vue&type=script&lang=js&"
export * from "./ModalDropdownIcon.vue?vue&type=script&lang=js&"
import style0 from "./ModalDropdownIcon.vue?vue&type=style&index=0&id=54739c87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54739c87",
  null
  
)

export default component.exports